<template>
  <section class="c-summary bg-white p-3 p-lg-4">
    <h1 class="fs-21 w-bold darks mb-3">Resumen del pedido:</h1>

    <b-skeleton-wrapper :loading="product.isLoading" class="mb-4">
      <template #loading>
        <div class="c-card-payment">
          <div class="c-card-payment__thumbnail overflow-hidden">
            <b-skeleton
              no-aspect
              height="100%"
              animation="fade"
              class="light mb-2"
            ></b-skeleton>
          </div>
          <div class="c-card-payment__body">
            <b-skeleton
              no-aspect
              width="100px"
              animation="fade"
              class="light mb-2"
            ></b-skeleton>
            <b-skeleton
              no-aspect
              animation="fade"
              class="light mb-2"
            ></b-skeleton>
            <b-skeleton
              no-aspect
              width="100px"
              animation="fade"
              class="light"
            ></b-skeleton>
          </div>
        </div>
      </template>

      <template>
        <div class="mb-4">
          <ul v-if="product.type == 'course'" class="c-payment-cards ul-reset">
            <li>
              <div class="c-card-payment">
                <div>
                  <figure class="c-card-payment__thumbnail br--small overflow-hidden">
                    <img
                      class="w-100 h-100 of--cover"
                      :src="product.data.thumbnail"
                      :alt="product.data.title" />
                  </figure>
                </div>
                <div class="c-card-payment__body">
                  <h3 class="c-card-payment__title w-sbold fs-18 darks mb-2">
                    {{ product.data.title }}
                  </h3>

                  <b-skeleton-wrapper :loading="price.isLoading" class="mb-4">
                    <template #loading>
                      <b-skeleton
                        no-aspect
                        width="100px"
                        animation="fade"
                        class="light"
                      ></b-skeleton>
                    </template>

                    <p v-if="step !== 2" class="mb-0">
                      <span class="third-color fs-18 w-bold mr-2">
                        {{ productFinalPrice }}
                      </span>
                      <span class="medium-gray w-sbold text-line-through">
                        {{ productOriginalPrice }}
                      </span>
                    </p>
                  </b-skeleton-wrapper>
                </div>
              </div>
            </li>
          </ul>
          <ul v-else class="c-payment-cards ul-reset">
            <li>
              <div class="c-card-payment c-card-payment--premium">
                <div>
                  <figure
                    class="c-card-payment__thumbnail br--small white overflow-hidden">
                    <div class="d-flex">
                      <i
                        v-for="star of getPremiumDetails('stars')"
                        :key="star.id"
                        class="c-corona iconf-king"></i>
                    </div>
                    <p class="mb-0 w-bold">{{ getPremiumDetails('label') }}</p>
                  </figure>
                </div>
                <div class="c-card-payment__body">
                  <h3 class="c-card-payment__title w-sbold fs-18 darks mb-0">
                    {{product.data ? product.data.title : ''}}
                  </h3>
                  <p class="mb-2">Acceso ilimitado a todos nuestros cursos</p>

                  <b-skeleton-wrapper :loading="price.isLoading" class="mb-4">
                    <template #loading>
                      <b-skeleton
                        no-aspect
                        width="100px"
                        animation="fade"
                        class="light"
                      ></b-skeleton>
                    </template>

                    <p v-if="step !== 2" class="mb-0">
                      <span class="third-color fs-18 w-bold mr-2">
                        {{ productFinalPrice }}
                      </span>
                      <span
                        v-if="(productFinalPrice != productOriginalPrice)"
                        class="medium-gray w-sbold text-line-through">
                        {{ productOriginalPrice }}
                      </span>
                    </p>
                  </b-skeleton-wrapper>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div
          v-if="!coupon.code.isValid
            || price.current.slug == 'duo'
            || price.current.slug == 'family'"
          class="c-hr mb-4 bg-color-gray"
        ></div>
        <div v-if="['duo', 'family'].includes(product.slug)" class="mb-4">
          <p class="mb-4">
            Luego de completar tu compra envíanos el nombre y correo de
            {{
              price.current.slug === 'duo'
                ? 'la otra persona' : 'las otras tres personas'
            }}
            que quieres agregar a tu suscripción a hola@arcux.net,
            y habilitaremos las cuentas en máximo 24 horas.
          </p>
          <div v-if="!coupon.code.isValid" class="c-hr bg-color-gray"></div>
        </div>
      </template>
    </b-skeleton-wrapper>

    <template v-if="step !== 2 && !isTrialPlan && !isCheckoutV2">
      <div v-if="!coupon.code.isValid" class="mb-4">
        <button
          @click="coupon.enable = !coupon.enable"
          class="c-link d-flex align-items-center"
        >
          <i class="iconf-ticket d-flex align-items-center fs-18 me-2"></i>
          ¿Tienes un cupón de descuento?
          <Icon
            :icon="(!coupon.enable) ? 'ci:chevron-big-down' : 'ci:chevron-big-up'"
            class="fs-18 ms-2"
          />
        </button>
        <div v-if="coupon.enable" class="c-form c-form--ghost mt-3">
          <div class="row">
            <div class="col col-12 col-md-8 col-lg-7 mb-4 mb-md-0">
              <input
                v-model="code"
                @input="code = $event.target.value.toUpperCase()"
                @keypress.enter="validateCoupon()"
                class="c-form__input w-100"
                :class="{'is-invalid' : isWrongField(coupon.code, 'multiple', 'coupon')}"
                type="text"
                placeholder="Código de descuento"
                required/>
              <span
                v-if="isWrongField(coupon.code, 'multiple', 'coupon')"
                class="c-form__error d-md-none"
              >
                Cupón incorrecto
              </span>
            </div>
            <div class="col col-12 col-md-4 col-lg-5">
              <button
                @click="validateCoupon()"
                :disabled="coupon.isLoading || coupon.code.value.length < 1"
                class="c-button c-button--primary w-100 h-100"
                :class="{loading : coupon.isLoading}">
                {{ (coupon.isLoading) ? 'Validando...' : 'Usar cupón' }}
                <img
                  class="c-button__spinner"
                  src="@/assets/images/animations/spinner-white.png" alt="loading" />
              </button>
            </div>
          </div>
          <span
            v-if="isWrongField(coupon.code, 'multiple', 'coupon')"
            class="c-form__error d-none d-md-block">
            Cupón incorrecto
          </span>
        </div>
      </div>
      <div v-if="coupon.code.isValid">
        <div class="c-hr mb-4 bg-color-gray"></div>
        <div class="row mb-0">
          <div class="col col-6">
            <p class="mb-0 w-sbold darks">Subtotal</p>
          </div>
          <div class="col col-6 text-end">
            <span class="fs-18 w-bold darks"> {{ productFinalPrice }} </span>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col col-6">
            <p class="mb-0 w-sbold darks d-flex flex-wrap">
              <span class="me-2">
                Descuento
              </span>
              <span class="c-coupon-code pri-color d-flex align-items-center">
                {{ coupon.code.value }}
                <button @click="clearCoupon" class="c-coupon-code__trash c-link ms-2">
                  <Icon icon="carbon:close" />
                </button>
              </span>
            </p>
          </div>
          <div class="col col-6 text-end">
            <span class="fs-18 w-bold alerts">- {{ couponAmount }}</span>
          </div>
        </div>
      </div>
    </template>

    <div class="c-invoice">
      <b-skeleton-wrapper :loading="price.isLoading">
        <template #loading>
          <div class="row align-items-center justify-content-between">
            <div class="col col-6">
              <b-skeleton
                no-aspect
                width="50%"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
              <b-skeleton
                no-aspect
                width="80%"
                animation="fade"
                class="light"
              ></b-skeleton>
            </div>
            <div class="col col-4">
              <b-skeleton
                no-aspect
                animation="fade"
                class="light"
              ></b-skeleton>
            </div>
          </div>
        </template>

        <div class="d-flex align-items-center justify-content-between">
          <div class="">
            <p
              class="mb-0 fs-18 w-sbold darks"
              v-text="step === 2 ? 'Total pagado' : 'Total a pagar'"
            >
            </p>
            <p class="mb-0 fs-14 d-none d-md-block">
              {{isCheckoutV2 ? 'Incluye impuestos' : 'Incluye 18% de impuestos'}}
            </p>
          </div>
          <div class="">
            <div class="c-amount text-end">
              <span
                v-if="step !== 2"
                class="medium-gray text-line-through w-sbold"
              >
                {{ productOriginalPrice }}
              </span>
              <span class="third-color w-bold ms-2">{{ productPaidPrice }}</span>
            </div>
          </div>
        </div>
      </b-skeleton-wrapper>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      arcux: {
        ...window.arcux,
      },

      price: {
        current: {
          name: '',
          plan: '',
          slug: '',
          amount: {
            original: 0,
            discount: 0,
            final: 0,
            paid: 0,
            currency: '',
          },
        },
        convertions: {},

        isDisabled: false,
        isLoading: true,
      },

      code: '',
    };
  },
  props: {
    step: Number,
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
      country: (state) => state.checkout.country,
      paymentMethod: (state) => state.checkout.paymentMethod,
      product: (state) => state.checkout.product,
      productPrice: (state) => state.checkout.price,
      coupon: (state) => state.checkout.coupon,
    }),

    productId() {
      let id = -1;

      if (this.$route.query.course_id) {
        id = this.$route.query.course_id;
      } else if (this.$route.query.bundle_id) {
        id = this.$route.query.bundle_id;
      } else if (this.$route.query.membership_id) {
        id = this.$route.query.membership_id;
      }

      return id;
    },
    productPlan() {
      return (this.$route.query.plan) ? this.$route.query.plan : '';
    },
    purchaseCode() {
      return (this.$route.query.pc) ? this.$route.query.pc : '';
    },
    purchaseCodeQuery() {
      return (this.$route.query.pc) ? `&purchase_code=${this.$route.query.pc}` : '';
    },

    productOriginalPrice() {
      return (this.price.current && this.price.current.name)
        ? `${this.price.current.amount.currency.symbol_full} ${Number(this.price.current.amount.original).toLocaleString('en')}`
        : '0.00';
    },
    productFinalPrice() {
      return (this.price.current && this.price.current.name)
        ? `${this.price.current.amount.currency.symbol_full} ${Number(this.price.current.amount.final).toLocaleString('en')}`
        : '0.00';
    },
    productPaidPrice() {
      const coupon = (this.coupon.current) ? Number(this.coupon.current.amount) : 0;

      return (this.price.current && this.price.current.name)
        ? `${this.price.current.amount.currency.symbol_full} ${(Number(this.price.current.amount.final) - coupon).toLocaleString('en')}`
        : '0.00';
    },

    couponAmount() {
      return (this.coupon.current)
        ? `${this.price.current.amount.currency.symbol_full} ${Number(this.coupon.current.amount).toFixed(2)}`
        : '0.00';
    },
    isTrialPlan() {
      return (this.$route.query.plan.search('trial') >= 0 || this.$route.query.plan.search('gratis') >= 0);
    },
    isCheckoutV2() {
      return this.$route.name === 'Checkout Payment V2' || this.$route.query.vertion === 'v2';
    },
    isMembershipV2() {
      return this.isCheckoutV2 && this.$route.query.membership_id;
    },
  },
  watch: {
    paymentMethod() {
      if (this.country.code === 'pe') {
        if (this.paymentMethod === 'paypal') {
          this.updateCountry({
            ...this.country,

            code: 'us',
          });
        }

        const countryCode = (this.country.code === 'world' || this.country.code !== 'pe')
          ? 'us'
          : 'pe';

        if (!this.price.convertions[countryCode] && !this.price.isLoading && this.product.data.id) {
          this.getProductPrice(countryCode);
        } else {
          this.price.current = this.price.convertions[countryCode];
        }
      }
    },
    'country.code': function countryCode() {
      this.clearCoupon();

      if (this.paymentMethod === 'visa' || this.paymentMethod === 'cash') {
        const code = (this.country.code === 'world' || this.country.code !== 'pe')
          ? 'us'
          : 'pe';

        if (!this.price.convertions[code] && !this.price.isLoading && this.product.data.id) {
          this.getProductPrice(code);
        } else {
          this.price.current = this.price.convertions[code];
        }
      }
    },
    code() {
      this.updateCoupon({
        ...this.coupon,
        code: {
          ...this.coupon.code,
          value: this.code,
        },
      });
    },
    price: {
      handler() {
        this.updatePrice(this.price);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.step === 2) {
      this.getOrder();
    } else {
      this.getProductData();
    }
  },
  methods: {
    ...mapActions([
      'updateCountry',
      'updateProduct',
      'updatePrice',
      'updatePaymentMethod',
      'updateCoupon',
    ]),

    isWrongField(field, type = 'multiple', context = 'user') {
      return (this[context].try || field.tested)
        && ((type === 'multiple') ? !field.isValid : !field);
    },

    getOrder() {
      const url = `${this.arcux.site}/api/v1/checkout/orders/${this.$route.params.order_id}/`;

      fetch(url)
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          const productType = (response.product) ? response.product.type : 'course';

          this.updateProduct({
            type: (productType === 'pack')
              ? 'course'
              : productType,
            data: response.product,
            isLoading: false,
          });

          this.updatePaymentMethod(response.method);

          this.price.current = {
            name: 'Arcux',
            amount: {
              final: response.price.amount,
              currency: { symbol_full: response.price.currency },
            },
          };

          /* TODO: Pending coupon: Used for send metrics sales */

          this.price.isLoading = false;

          if (this.purchaseCode) {
            this.getPurchaseData(this.purchaseCode);
          }

          // if (this.mixpanel.activation === 'Email') this.setObjectMPPurchase();
        })
        .catch(() => {
          // window.location.href = `${this.arcux.site}/404`;
        });
    },
    getProductData() {
      const url = (this.isMembershipV2)
        ? `${process.env.VUE_APP_API_V2}/memberships/${this.productPlan}/checkout`
        : `${this.arcux.site}/api/v1/courses/${this.productId}/checkout/?plan=${this.productPlan}${this.purchaseCodeQuery}`;

      fetch(url)
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((data) => {
          const productType = (data.data) ? data.data.type : 'course';

          this.configCountryCode(data);

          this.updateProduct({
            type: (productType === 'pack')
              ? 'course'
              : productType,
            data: data.data,
            isLoading: false,
          });

          if (this.purchaseCode) {
            this.getPurchaseData(this.purchaseCode);

            if (Object.prototype.hasOwnProperty.call(data.data, 'active_price')) {
              this.price.isDisabled = data.data.active_price;
            }
          } else {
            const priceCountryCode = (this.country.code === 'world' || this.country.code !== 'pe') ? 'us' : 'pe';

            this.getProductPrice(priceCountryCode);

            if (priceCountryCode === 'pe') {
              this.getProductPrice('us', true);
            }
          }

          if (this.purchaseCode && productType === 'subscription') {
            window.fbq('track', 'InitiateCheckout');
          }

          // if (this.mixpanel.activation === 'Email') this.setObjectMPPurchase();
        })
        .catch(() => {});
    },
    getProductPrice(country, extra = false) {
      const countryCode = (country === 'world' || country !== 'pe') ? 'us' : 'pe';

      this.price.isLoading = true;

      const url = `${this.arcux.site}/api/v1/products/${this.productId}/price/?selected_country=${countryCode}&plan=${this.productPlan}`;

      fetch(url)
        .then((res) => res.json())
        .then((response) => {
          if (response.status) {
            const price = {
              name: response.data.name,
              plan: response.data.plan,
              slug: response.data.slug,
              amount: {
                original: response.data.amount,
                final: response.data.total,
                discount: response.data.discount,
                currency: response.data.currency,
              },
            };

            if (!extra) {
              this.price.current = price;
            }

            if (!this.price.convertions[countryCode]) {
              this.price.convertions[countryCode] = price;
            }

            this.price.isLoading = false;

            this.sendGTMBeingCheckout();
          } else {
            this.price.isLoading = false;

            window.location.href = this.product.type === 'course'
              ? this.product.data.url
              : `${this.arcux.site}/es/planes`;
          }
        })
        .catch(() => {});
    },
    getPremiumDetails(type) {
      return (type === 'label') ? 'PREMIUM' : 1;
    },
    getPurchaseData(purchaseCode) {
      const url = (this.isCheckoutV2)
        ? `${process.env.VUE_APP_API_V2}/purchases/${purchaseCode}`
        : `${this.arcux.site}/api/v1/purchase/${purchaseCode}`;

      fetch(url)
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (!response.status) {
            throw response;
          }

          this.price.current = {
            name: 'arcux',
            amount: {
              final: response.data.price,
              currency: { symbol_full: response.data.currency_symbol },
            },
          };

          this.price.isLoading = false;

          if (this.step === 1) {
            this.$router.push({
              path: `/checkout/order-received/${response.data.order}`,
              query: {
                ...(this.$route.query.course_id && { course_id: this.productId }),
                ...(this.$route.query.bundle_id && { bundle_id: this.productId }),
                ...(this.$route.query.membership_id && { membership_id: this.productId }),
                plan: this.productPlan,
                pc: this.purchaseCode,
              },
            });
          }
        })
        .catch(() => {
          window.location.href = `${this.arcux.site}/404`;
        });
    },

    configCountryCode(priceData) {
      const countryCode = (priceData.data && priceData.data.country_code)
        ? priceData.data.country_code
        : 'us';

      if (!window.localStorage.getItem('arcux_country')) {
        this.updateCountry({
          ...this.country,
          code: countryCode,
        });
      }

      this.updateCountry({
        ...this.country,
        codeOrigin: countryCode,
      });
    },

    validateCoupon(country = '-1', extra = false) {
      let countryCode = (extra) ? country : this.country.code;

      countryCode = (countryCode === 'world' || countryCode !== 'pe') ? 'us' : 'pe';

      if (!extra) {
        this.updateCoupon({
          ...this.coupon,
          isLoading: true,
        });
      }

      if (!this.coupon.convertions[countryCode]) {
        let url = `${this.arcux.site}/api/v1/checkout/coupon/verify?code=${this.coupon.code.value}`;

        url += `&productId=${this.productId}&plan=${this.productPlan}&selected_country=${countryCode}`;

        url = !(this.userData && this.userData.id)
          ? `${url}&user_tmp=${this.user_temp}`
          : url;

        fetch(url)
          .then((res) => res.json())
          .then((response) => {
            if (!response.status) {
              throw response;
            }

            const amount = response.data;

            if (!extra) {
              this.updateCoupon({
                ...this.coupon,
                current: amount,
              });
            }

            if (!this.coupon.convertions[countryCode]) {
              this.updateCoupon({
                ...this.coupon,
                convertions: {
                  ...this.coupon.convertions[countryCode],
                  [countryCode]: amount,
                },
              });
            }

            this.updateCoupon({
              ...this.coupon,
              code: {
                ...this.coupon.code,
                isValid: true,
              },
            });

            if (countryCode === 'pe' && !this.price.convertions.us) {
              this.validateCoupon('us', true);
            }
          })
          .catch(() => {
            this.updateCoupon({
              ...this.coupon,
              try: true,
            });
          })
          .finally(() => {
            this.updateCoupon({
              ...this.coupon,
              isLoading: false,
            });
          });
      } else {
        this.updateCoupon({
          ...this.coupon,
          try: true,
          current: this.coupon.convertions[countryCode],
          code: {
            ...this.coupon.code,
            isValid: true,
          },
        });

        window.setTimeout(() => {
          this.updateCoupon({
            ...this.coupon,
            isLoading: false,
          });
        }, 1000);
      }
    },
    clearCoupon() {
      this.updateCoupon({
        ...this.coupon,
        try: false,
        current: null,
        code: {
          isValid: false,
          value: '',
        },
      });
    },

    sendGTMBeingCheckout() {
      window.dataLayer.push({
        event: 'begin_checkout',
        currency: this.price.current.amount.currency.code,
        value: Number(this.price.current.amount.final).toFixed(2),
        items: [
          {
            item_id: this.productId,
            item_name: this.product.data.title,
            price: Number(this.price.current.amount.final).toFixed(2),
          },
        ],
      });
    },
  },
};
</script>
